<template>
  <div>
    <div class="sticky-top">
      <div class="card m-b-0">
        <div class="card-body text-right m-r-30">
          <a :href="story.canonical_url" target="_blank" class="btn btn-outline m-r-10">
            <i class="fa fa-external-link"></i>
            Voir la page
          </a>
          <router-link :to="{name: 'story', params: {id: $route.params.id}, query: {edit: true}}" class="btn btn-outline m-r-10">
            <i class="fa fa-chevron-circle-left"></i>
            Retour
          </router-link>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="container-fluid">
        <transition name="fade" mode="out-in">
          <div class="card" v-loading="loading">
            <div class="card-header">
              <h2 class="h3">
                {{ story.title }}
              </h2>
              <p>
                Prévisualiser et recadrer les variantes de l’image d’illustration
              </p>
            </div>
            <div v-loading="saving" class="card-body">
              <div class="row">
                <div class="col-sm-11">
                  <el-tabs
                    v-if="edit == false"
                    v-model="activeTab"
                    tab-position="left">
                    <el-tab-pane
                      v-for="(thumbnail, key) in constants.STORY_THUMBNAILS"
                      :key="key"
                      :name="key"
                      :label="thumbnail.description">
                      <div
                        v-if="story.id"
                        class="d-flex justify-content-center"
                        style="min-height: 340px;">
                        <div class="align-self-center p-1 bd-highlight">
                          <el-image
                            :src="key | thumbnail(story, true)"
                            fit="contain"></el-image>
                          <p class="text-center text-muted m-none">
                            {{ thumbnail.w }}px / {{ thumbnail.h }}px
                          </p>
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                  <vue-cropper
                    v-if="edit && story.id && constants.STORY_THUMBNAILS"
                    ref="cropper"
                    :src="`stories/${story.id}/cover-image/` | api_url"
                    alt="Source Image"
                    dragMode="move"
                    :ready="cropReady"
                    :minContainerHeight="500"
                    :viewMode="1"
                    :rotatable="false"
                    :cropBoxResizable="false"
                    :toggleDragModeOnDblclick="false"
                    :cropmove="cropImage"></vue-cropper>
                    <p
                       v-if="edit && story.id && constants.STORY_THUMBNAILS"
                       class="text-center">
                      {{ constants.STORY_THUMBNAILS[activeTab].description }}
                      - Taille {{ constants.STORY_THUMBNAILS[activeTab].w }}px /
                      {{ constants.STORY_THUMBNAILS[activeTab].h }}px
                    </p>
                </div>
                <div class="col-sm-1 text-right">
                  <span v-if="!edit">
                    <a href @click.prevent="setEditMode()" class="btn btn-sm btn-primary">
                      <i class="fa fa-crop"></i>
                    </a>
                  </span>
                  <span v-else>
                    <a href @click.prevent="edit = !edit" class="btn btn-sm btn-info">
                      <i class="fa fa-eye"></i>
                    </a>
                    <a href @click.prevent="saveCroppedImage()" class="btn btn-sm btn-primary">
                      <i class="fa fa-save"></i>
                    </a>
                  </span>
                </div>
              </div>
            </div>
            <!-- <pre>{{ constants }}</pre> -->
            <!-- <pre>{{ story }}</pre> -->
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  computed: mapGetters({
    constants: 'constants',
    story: 'story'
  }),
  components: {
    VueCropper
  },
  data () {
    return {
      loading: false,
      saving: false,
      activeTab: 'thumb_hero',
      edit: false,
      mask: 'id,title,headline,content,status,cover_image_url,scheme,canonical_url,' +
      'cover_image_credits,scope,primary_category{id,label},created_at,updated_at,' +
      'slug,comments_allowed,published_at,is_published,' +
      'authors{id,screenname},' +
      'attachments_by_keys,' +
      'publication_rules,' +
      'story_tags{id,label},' +
      'story_categories{id,label},'
    }
  },
  watch: {
    '$route' (to, from) {
      this.edit = JSON.parse(to.query.edit)
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.loading = true
      if (this.$route.query.edit) {
        this.edit = this.$route.query.edit
      }
      this.$store.dispatch('getConstants', {
        params: {
          'keys': 'STORY_THUMBNAILS'
        }
      })
      this.$store.dispatch('getStory', {
        id: this.$route.params.id,
        headers: {
          'X-Fields': this.mask
        }
      }).then(() => {
        this.loading = false
      })
    },
    cropImage () {},
    setEditMode () {
      this.edit = true
    },
    setCrop (thumbKey) {
      let thumb = this.constants.STORY_THUMBNAILS[thumbKey]
      let container = this.$refs.cropper.getContainerData()
      this.$refs.cropper.setCropBoxData({
        width: thumb.w,
        height: thumb.h,
        top: (container.height - thumb.h) / 2,
        left: (container.width - thumb.w) / 2
      })
    },
    saveCroppedImage () {
      this.saving = true
      let thumb = this.constants.STORY_THUMBNAILS[this.activeTab]
      let cropOptions = {
        width: thumb.w,
        height: thumb.h,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high'
      }
      this.$refs.cropper.getCroppedCanvas(cropOptions).toBlob((blob) => {
        const formData = new FormData()
        formData.append('image', blob);
        formData.append('thumbnail', this.activeTab);

        this.axios.post(`/stories/${this.story.id}/cover-image/`,
          formData
        ).then((response) => {
          this.saving = false
          this.edit = false
        })
      })
    },
    cropReady () {
      this.setCrop(this.activeTab)
    }
  }
}
</script>
<style>
</style>
